import React from "react";
import "./Communitymember.css";

// Import member images
import donaImg from "../../assets/images/gifs/dona-member.png";
import batrusImg from "../../assets/images/gifs/batrus-member.png";
import daivoImg from "../../assets/images/gifs/daivo-member.png";
import malcoImg from "../../assets/images/gifs/malco-member.png";

// Import header, profile, tabs, and sidebar components
import CommunityHeader from "../../components/Community/CommunityHeader";
import CommunityProfileDescription from "../../components/Community/Communityprofiledescription";
import CommunityTabsRoom from "../../components/Community/Communitytabsroom";
import CommunityNavBar from "../../components/Community/CommunityNavBar";

const CommunityMember = () => {
  const members = [
    { name: "dona", img: donaImg, color: "orange" },
    { name: "batrus", img: batrusImg, color: "blue" },
    { name: "daivo", img: daivoImg, color: "green" },
    { name: "malco", img: malcoImg, color: "red" },
  ];

  return (
    <div className="CommunityMember-container">
      {/* Sidebar */}
      <CommunityNavBar />

      {/* Main Content */}
      <div className="CommunityMember-content">
        {/* Top Section */}
        <CommunityHeader roomTitle="JOHN HOSTING" roomName="ROOM NAME: MEMBERS" />
        <CommunityProfileDescription
          userName="JOHN HOSTING"
          description="Welcome to the Members Dashboard. Manage and explore all members in this room."
          avatarSrc="john-prof-pic-07.png"
        />

        {/* Tabs Section */}
        <CommunityTabsRoom />

        {/* Header Section */}
        <header className="communityMember-header">
          <h1 className="communityMember-title">Members Dashboard</h1>
          <p className="communityMember-description">
            Manage and explore all members in this room.
          </p>
        </header>

        {/* Grid Section */}
        <section className="communityMember-grid-section">
          <h2 className="communityMember-roomName">BEBOOS</h2>
          <div className="communityMember-grid">
            <div className="communityMember-grid-item"></div>
            <div className="communityMember-grid-item"></div>
            <div className="communityMember-grid-item"></div>
            <div className="communityMember-grid-item"></div>
            <div className="communityMember-grid-item"></div>
            <div className="communityMember-grid-item"></div>
          </div>
        </section>

        {/* Members List Section */}
        <section className="communityMember-list-section">
          <h2 className="communityMember-list-title">Members</h2>
          <div className="communityMember-list">
            {members.map((member, index) => (
              <div key={index} className="communityMember-item">
                <div className="communityMember-avatar-container">
                  <img
                    src={member.img}
                    alt={member.name}
                    className="communityMember-avatar"
                  />
                  <div
                    className="communityMember-status-dot"
                    style={{ backgroundColor: member.color }}
                  ></div>
                </div>
                <p
                  className="communityMember-name"
                  style={{ backgroundColor: member.color }}
                >
                  {member.name}
                </p>
              </div>
            ))}
          </div>
          <p className="communityMember-scrollHint">Scroll right to view the rest</p>
        </section>
      </div>
    </div>
  );
};

export default CommunityMember;
